<template>
  <b-modal :active="active" has-modal-card :on-cancel="onClose">
    <div class="roles modal-content">
      <div class="box">
        <header class="title is-5">Assign Role</header>
        <form class="roles__form" @submit.prevent="assignRolesHandler">
          <b-field label="Email">
            <b-input
              disabled
              icon="format-title"
              placeholder="Email"
              required
              type="text"
              :value="email"
            />
          </b-field>
          <b-field label="Roles">
            <v-select
              v-model="roles"
              :close-on-select="false"
              multiple
              :options="admin.roles"
              placeholder="Roles"
              :searchable="false"
            >
              <template #selected-option="{ label }">
                {{ startCase(label) }}
              </template>
              <template #option="{ label }">
                {{ startCase(label) }}
              </template>
            </v-select>
          </b-field>
          <b-button
            class="is-fullwidth"
            :loading="admin.submitting"
            native-type="submit"
            type="is-primary"
          >
            Assign
          </b-button>
        </form>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import startCase from 'lodash/startCase';

export default {
  props: {
    user: Object,
    onClose: Function
  },
  data: function() {
    return {
      roles: []
    };
  },
  computed: {
    ...mapState(['admin']),
    active() {
      return Boolean(this.user);
    },
    email() {
      return this.user ? this.user.email : '';
    }
  },
  methods: {
    ...mapActions('admin', ['assignRoles']),
    async assignRolesHandler() {
      try {
        await this.assignRoles({ userId: this.user.id, roles: this.roles });
        this.onClose();
        this.$buefy.toast.open('Assigned roles successfully!');
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to assign roles!',
          type: 'is-danger'
        });
      }
    },
    startCase: startCase
  },
  watch: {
    user: function(newValue) {
      if (newValue) {
        this.roles = newValue.roles || [];
      } else {
        this.roles = [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/mixins.sass';

.roles {
  overflow: visible;
  width: auto;

  &__form {
    @include tablet {
      width: 25rem;
    }
  }
}
</style>
